{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/IDDSI",
	"name": "IDDSI",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "IDDSI",
	"purpose": "Standard des textures alimentaires et des liquides pour les personnes présentant des troubles de la déglutition",
	"description": "Les tests IDDSI sont destinés à confirmer les caractéristiques d’écoulement ou de consistance d’un produit donné au moment du test. Les tests doivent être réalisés sur les aliments et les boissons dans les conditions de service prévues (notamment la température).",
	"item": [
		{
			"linkId": "30200",
			"text": "Cohérence nutritionnelle",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "30201",
						"display": "7. Normal"
					}
				},
				{
					"valueCoding": {
						"code": "30202",
						"display": "EC7. Facile à mastiquer"
					}
				},
				{
					"valueCoding": {
						"code": "30203",
						"display": "6. Petitis morceaux tendres"
					}
				},
				{
					"valueCoding": {
						"code": "30204",
						"display": "5. Haché lubrifié"
					}
				},
				{
					"valueCoding": {
						"code": "30205",
						"display": "4. Purée lisse"
					}
				},
				{
					"valueCoding": {
						"code": "30206",
						"display": "3. Purée fluide, modérément épais"
					}
				},
				{
					"valueCoding": {
						"code": "30207",
						"display": "2. Légèrement épais"
					}
				},
				{
					"valueCoding": {
						"code": "30208",
						"display": "1. Très légèrement épais"
					}
				},
				{
					"valueCoding": {
						"code": "30209",
						"display": "0. Liquide"
					}
				}
			]
		}
	]
}
